import {
  FETCH_RECORDS,
  FETCH_RECORDS_SUCCESS,
  FETCH_RECORDS_FAIL,
  WAIT,
  WAIT_SUCCESS,
  WAIT_FAIL
} from "./types";
import {
  delRequest,
  getRequest,
  postRequest,
  putRequest
} from "../../../core/network";
import endpoints from "../../../constants/endPoints.json";
import { notification } from "antd";

export const getOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsEmployee.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const assignOrder = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsEmployee.assign)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate(`/ims/employee/order/${data.order._id}`)
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

const syncPackOrderItems = (dispatch, data) => {
  if (!data?.orderItems) return;
  const payload = { orderItems: data.orderItems };
  if (data.newOrder) {
    payload.order = data.newOrder;
  }
  dispatch({
    type: FETCH_RECORDS_SUCCESS,
    payload
  });
};

export const packOrderItem = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return putRequest(data, undefined, undefined, token, endpoints.imsEmployee.pack)
    .then((response) => {
      const { data, status } = response;
      syncPackOrderItems(dispatch, data);
      if (status === 201) {
        navigate && navigate("/ims/employee");
      }
      dispatch({
        type: WAIT_SUCCESS
      });
      return response;
    })
    .catch((err) => {
      syncPackOrderItems(dispatch, err?.response?.data);
      console.log(err);
      dispatch({
        type: WAIT_FAIL
      });
      throw err;
    });
};

export const finalizeOrder = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsEmployee.finalize)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const cancelPackingOrder = (navigate) => (dispatch, useState) => {
  dispatch({
    type: FETCH_RECORDS_SUCCESS,
    payload: {order: null}
  });
  navigate && navigate("/ims/employee")
};